import { useQuery } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';

import { GatewaySpinner } from '@/_shared/components/GatewayShell';
import { usePageTitle } from '@/_shared/hooks/usePageTitle';
import { orpc } from '@/_shared/lib/orpc';

import { finishHostedUiSignIn } from '../lib/hosted-ui';

/** `/login/callback`: the Hosted UI returns here after Google or SSO with the shared session (ACT2-879). */
export function HostedUiCallback(): React.ReactElement {
  usePageTitle('Signing in');
  const { data: providers, isLoading } = useQuery(orpc.auth.providers.queryOptions());
  // The code works once, so the flow must not run twice.
  const started = useRef(false);
  useEffect(() => {
    if (isLoading || started.current) return;
    started.current = true;
    void finishHostedUiSignIn(window.location.search, providers?.nativeSignIn ?? null).then((path) => {
      // `replace` keeps the code out of the history.
      window.location.replace(path);
    });
  }, [isLoading, providers]);
  return <GatewaySpinner mode="fullScreen" />;
}
